import { Box, Text, Button, Flex, Image } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { links } from "../../data/Navbar";

import Drawer from "../../hooks/Drawer";
import NavbarDrawer from "./NavbarDrawer";
import { FiMenu } from "react-icons/fi";
import logo from "../../assets/images/hLogo.png";
const NavLink = ({ href, children }) => {
  const location = useLocation();

  const handleClick = (event) => {
    event.preventDefault();

    const sectionId = href.replace("/", "");
    const section = document.getElementById(sectionId);

    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const isActive = location.pathname === href;

  return (
    <Box position="relative" display="inline-block" mx={3}>
      <Text
        as="a"
        onClick={handleClick}
        color={isActive ? "brand.200" : "rgba(255, 255, 255, 1)"}
        cursor={"pointer"}
        fontWeight={"600"}
        fontSize="14px"
        _hover={{
          color: "white",
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: "-5px",
            left: 0,
            right: 0,
            height: "3px",
            backgroundColor: "brand.200",
          },
        }}
      >
        {children}
      </Text>
    </Box>
  );
};

const Header = () => {
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const {
    isOpen: isOpenNavbar,
    openDrawer: openNavbar,
    closeDrawer: closeNavbar,
  } = Drawer();

  const formUrl =
    "https://forms.zohopublic.com/IDEATORSCUP/form/CYPRUSROUNDREGISTRATION/formperma/Tyx16DXRUfRvZhmvGzZIq3-AiDXmFma208KpF8Ib9S4";

  const handleRegisterClick = () => {
    window.open(formUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <Box
        py={8}
        alignItems={"center"}
        transition="background-color 0.3s ease"
        position="sticky"
        top={0}
        // m="auto"
        px={12}
        zIndex={1000}
        w="100%"
        display={{ base: "none", xl: "flex" }}
        justifyContent={"space-between"}
        bg={scrolling ? "brand.150" : "transparent"}
      >
        <Box>
          <Image src={logo} w="36px " h="32px"></Image>
        </Box>

        <Box
          w="55%"
          display="flex"
          alignItems="center"
          justifyContent={"space-between"}
        >
          <Box display="flex" alignItems="center">
            {links.map((link) => (
              <NavLink key={link.href} href={link.href}>
                {link.label}
              </NavLink>
            ))}
          </Box>

          <Box display={"flex"}>
            <Button
              borderRadius={"8px"}
              fontSize={"14px"}
              onClick={handleRegisterClick}
              _hover={{ bg: "brand.200", color: "black" }}
              color={scrolling ? "black" : "white"}
              bg={scrolling ? "brand.200" : "brand.150"}
            >
              Register Now
            </Button>
          </Box>
        </Box>
      </Box>

      <Flex
        position="sticky"
        top={0}
        m="auto"
        zIndex={1000}
        flexWrap="wrap"
        alignItems={"center"}
        justifyContent={"space-between"}
        py={6}
        px={{ base: 4, md: 12, lg: 14, xl: 20 }}
        display={{ base: "flex", xl: "none" }}
        bg={scrolling ? "brand.150" : "transparent"}
      >
        <Image src={logo} w="36px " h="32px"></Image>

        <Box onClick={openNavbar} display={"flex"} alignItems={"center"}>
          <FiMenu
            color={scrolling ? "white" : "rgba(170, 87, 225, 1)"}
            size={24}
          />
        </Box>
      </Flex>

      <NavbarDrawer isOpen={isOpenNavbar} onClose={closeNavbar}></NavbarDrawer>
    </>
  );
};

export default Header;
